declare global {
  interface Window {
    ym: (a: number, b: string, c: string) => void;
  }
}

declare const ym: (a: number, b: string, c: string) => void;

const id = 90937796;

let isYandexMetrikaReady = false;
const eventQueue: Array<{ type: string; value: string }> = [];

// Проверяем готовность Яндекс.Метрики каждые 100мс
const checkYandexMetrikaReady = () => {
  if (typeof window !== 'undefined' && typeof window.ym === 'function') {
    isYandexMetrikaReady = true;
    // Отправляем все накопленные события
    eventQueue.forEach(({ type, value }) => {
      try {
        ym(id, type, value);
      } catch (error) {
        console.error(`Error sending queued metrik: ${type} ${value}`, error);
      }
    });
    eventQueue.length = 0;
  } else {
    setTimeout(checkYandexMetrikaReady, 100);
  }
};

// Запускаем проверку при первом импорте
if (typeof window !== 'undefined') {
  checkYandexMetrikaReady();
}

export const sendMetrik = (type: string, value: string) => {
  if (!isYandexMetrikaReady) {
    eventQueue.push({ type, value });
    return;
  }

  try {
    ym(id, type, value);
  } catch (error) {
    console.error(`Error sending metrik: ${type} ${value}`, error);
  }
};
